import React, { useState, useEffect, useMemo } from 'react'
import { setProps } from 'redux/actions'
import { connect } from 'react-redux'
import { store } from '../../index'
import { Config, IISMethods } from 'config/IISMethods'
import ModalRSuite from 'view/Components/ModalRsuite'
import lock from 'assets/images/lock.svg'
import TelephoneInput from 'view/Components/TelephoneInput'
import backarrow from 'assets/images/backarrow.svg'
import Loader from 'view/Components/Loader'
import Header from 'components/Header'
import useService from 'hooks/useService'
import { useSocket } from "hooks/useSocket"
import { getServerTime } from 'hooks/serverTimeUtils'
import UnlockingLoader from 'components/UnlockingLoader'

const UnlockDoorView = (props) => {
    const getCurrentState = () => store.getState()
    const { socketEmit } = useSocket()
    const { getStorageData } = useService()
    const [phoneError, setPhoneError] = useState(false); // 🔥 Track phone error
    const [serverTime, setServerTime] = useState(null);

    useEffect(() => {
        const updateTime = async () => {
            const st = await getServerTime({ socketEmit, getStorageData, IISMethods });
            setServerTime(st);
        };
        updateTime(); // ✅ run immediately
        const interval = setInterval(updateTime, 10000);
        return () => clearInterval(interval);
    }, [getStorageData, socketEmit]);

    const handlePhoneInputChange = (e) => {
        let numberRegex = /^\d+$/;
        const value = e.target.value;
        if (numberRegex.test(value) || value === '') {
            props.handleFormData('input-text', 'phoneno', value);
            if (value && value.length >= 10) {
                setPhoneError(false); // ✅ Valid number, remove error
            }
        }
    };

    const handleSendClick = () => {
        const phone = getCurrentState().formData.phoneno;
        if (!phone) {
            setPhoneError(true); // ❌ Show error
        } else {
            setPhoneError(false); // ✅ No error
            let { DigitalkeyData } = props.LinkData || {}
            let { phonenocountrycode, phoneno } = getCurrentState().formData
            if (`+${phonenocountrycode}${phoneno}` === DigitalkeyData?.fullcontact) { // first check is number same as mention in link
                props.handleGrid({ message: `You can't send the link to the same phone number.` }, 'modal', 'errormodal', 1)
            } else {
                let hasError = getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.length > 1 ? props.multiRoom?.length > 0 : getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.length === 1 ? true : getCurrentState().linkData?.ReservationData?.length === 1
                if (hasError) {
                    props.CoudeSend(); // proceed
                } else {
                    props.handleGrid(Config.ErrorMessages['multipleRoom'], 'modal', 'errormodal', 1)
                }
            }
        }
    };

    const MultipletransformLockData = ({ currentMinutes }) => {
        const dummyId = Config.dummyid;
        const { RoomlockData = [], ArealockData = [], PropertyData, ReservationData = [], DigitalkeyData, AreaDashboardData = [], OnetimekeyData = [] } = props.LinkData || {};
        const groupData = IISMethods.getCopy([
            ...(Array.isArray(RoomlockData) ? RoomlockData : []),
            ...(Array.isArray(ArealockData) ? ArealockData : [])
        ]) || [];

        let isReserved = (DigitalkeyData?.reservationid && DigitalkeyData?.reservationid !== Config.dummyid) ? 1 : 0;
        const isVisible = props.visible;

        if (!PropertyData || !DigitalkeyData || (isReserved && isVisible === null)) {
            return [];
        }

        // Helper: Convert date to minutes with memoization
        const getTimeInMinutes = (() => {
            const cache = new Map();
            return (dateString) => {
                if (!dateString) return 0;
                if (cache.has(dateString)) return cache.get(dateString);
                const date = new Date(dateString);
                const minutes = date.getHours() * 60 + date.getMinutes();
                cache.set(dateString, minutes);
                return minutes;
            };
        })();

        // Helper: Find reservation by room ID
        const findReservationByRoomId = (roomId) => {
            if (!Array.isArray(ReservationData)) return null;
            return ReservationData.find(reservation => reservation.roomnoid === roomId);
        };

        // Helper: Find area guest by area ID and phone number
        const findAreaGuestByAreaId = (areaId, fullcontact) => {
            if (!Array.isArray(AreaDashboardData)) return null;
            return AreaDashboardData.find(areaGuest =>
                areaGuest.areaid === areaId &&
                `+${areaGuest.countrycode}${areaGuest.phoneno}` === fullcontact
            );
        };

        // Helper: Get guest details from reservation
        const getGuestDetailsFromReservation = (reservation, fullcontact) => {
            if (!reservation?.keyaccessguestdetails) return null;
            return reservation.keyaccessguestdetails.find(guest =>
                `+${guest.countrycode}${guest.phoneno}` === fullcontact
            );
        };

        // Helper: Check area lock status based on bound rooms
        const getAreaLockStatus = (lock, isWithinTimingRange) => {
            if (!lock.roomnoid || !Array.isArray(lock.roomnoid)) {
                return getGeneralAreaStatus(lock);
            }

            const roomStatuses = [];
            const currentDateOnly = new Date(new Date(PropertyData?.systemdate).toDateString());

            for (const roomId of lock.roomnoid) {
                const reservation = findReservationByRoomId(roomId);
                if (reservation) {
                    const guest = getGuestDetailsFromReservation(reservation, DigitalkeyData?.fullcontact);

                    if (guest) {
                        const checkoutDateOnly = new Date(new Date(guest.checkoutdate || reservation.checkoutdate).toDateString());
                        const isExpired = currentDateOnly > checkoutDateOnly;

                        roomStatuses.push({
                            roomId,
                            reservation,
                            guest,
                            isExpired,
                            isCheckedOut: reservation.ischeckout === 1,
                            isNotCheckedOut: reservation.ischeckout === 0,
                            isActive: guest.isactive === 1,
                            isAllInactive: reservation.ischeckin === 0 && reservation.ischeckout === 0 &&
                                reservation.iscancel === 0 && reservation.noshow === 0
                        });
                    }
                }
            }

            if (DigitalkeyData.isonetimekey === 1 && ReservationData.length === 0 && DigitalkeyData.reservationid === Config.dummyid) {
                if (lock.timings && lock.timings.length > 0 && !isWithinTimingRange) {
                    return { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
                } else {
                    return { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' }
                }
            }

            if (roomStatuses.length === 0) {
                return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
            }

            const allExpiredOrCheckedOut = roomStatuses.every(status =>
                status.isExpired || status.isCheckedOut
            );

            const allInactive = roomStatuses.every(status =>
                !status.isActive || status.isAllInactive
            );

            const hasValidAccess = roomStatuses.some(status =>
                status.isActive && !status.isCheckedOut && !status.isExpired && !status.isAllInactive
            );

            const hasVisibleValidRoom = isVisible && roomStatuses.some(status =>
                status.isNotCheckedOut && status.isActive && !status.isExpired
            );

            if (allInactive) {
                return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
            }

            if (allExpiredOrCheckedOut) {
                return { id: 2, subtitle: 'Expired', className: 'unlock-card-expired', textclassName: 'unlock-card-expired-text' };
            }

            if (hasVisibleValidRoom) {
                const allVisibleInactive = roomStatuses.filter(status => status.isNotCheckedOut && status.isActive)
                    .every(status => status.isAllInactive && status.reservation.noshow === 0);

                if (allVisibleInactive && DigitalkeyData?.isonetimekey !== 1) {
                    return { id: 3, subtitle: 'Unavailable asa', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
                }

                if (hasValidAccess) {
                    // Check timing range for area locks
                    if (lock.timings && lock.timings.length > 0 && !isWithinTimingRange) {
                        return { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
                    }
                    return { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' };
                }
                return { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
            }

            if (hasValidAccess) {
                const validRooms = roomStatuses.filter(status =>
                    status.isActive && !status.isCheckedOut && !status.isExpired && !status.isAllInactive
                );

                const allRestrictedByVisibility = validRooms.every(status =>
                    !isVisible || (status.isAllInactive && status.reservation.noshow === 0 && status.reservation.isopen === 0)
                );

                if (allRestrictedByVisibility) {
                    return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
                }

                // Check timing range for area locks
                if (lock.timings && lock.timings.length > 0 && !isWithinTimingRange) {
                    return { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
                }

                return { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' };
            }

            return { id: 2, subtitle: 'Expired', className: 'unlock-card-expired', textclassName: 'unlock-card-expired-text' };
        };

        // Helper: Get general area status (updated to handle array)
        const getGeneralAreaStatus = (lock, isWithinTimingRange) => {
            // Try to find area guest data by lock's area ID or booking data's area ID
            const areaId = lock?.roomorareaid || DigitalkeyData?.areaid;

            if (areaId !== dummyId) {
                const areaGuest = findAreaGuestByAreaId(areaId, DigitalkeyData?.fullcontact);

                if (areaGuest) {
                    const currentDateOnly = new Date(new Date(PropertyData?.systemdate).toDateString());
                    const checkoutDateOnly = areaGuest?.checkoutdate ?
                        new Date(new Date(areaGuest.checkoutdate).toDateString()) : null;
                    const isExpired = checkoutDateOnly && currentDateOnly > checkoutDateOnly;
                    const isGuestInactive = areaGuest?.isactive === 0;
                    const isCheckedOut = areaGuest?.ischeckout === 1;
                    const isAllInactive = areaGuest?.ischeckin === 0 && areaGuest?.ischeckout === 0 &&
                        areaGuest?.iscancel === 0 && areaGuest?.noshow === 0;

                    if (isGuestInactive) {
                        return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
                    }

                    if (isCheckedOut) {
                        return { id: 2, subtitle: 'Expired', className: 'unlock-card-expired', textclassName: 'unlock-card-expired-text' };
                    }

                    if (isExpired) {
                        return { id: 2, subtitle: 'Expired', className: 'unlock-card-expired', textclassName: 'unlock-card-expired-text' };
                    }

                    if (isVisible && areaGuest?.ischeckout === 0) {
                        if (isAllInactive && areaGuest?.noshow === 0) {
                            return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
                        }
                        // Check timing range for area locks
                        if (lock.timings && lock.timings.length > 0 && !isWithinTimingRange) {
                            return { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
                        }
                        return { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' };
                    }

                    if (isAllInactive && areaGuest?.noshow === 0 && areaGuest?.isopen === 0) {
                        return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
                    }

                    // Check timing range for area locks
                    if (lock.timings && lock.timings.length > 0 && !isWithinTimingRange) {
                        return { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
                    }

                    return { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' };
                }
            }

            return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
        };

        // Helper: Get room lock status
        const getRoomLockStatus = (lock, isWithinTimingRange) => {
            const reservation = findReservationByRoomId(lock.roomorareaid);

            // Check if this lock has one-time key enabled
            if (lock.isonetimekey === true) {
                // Find matching one-time key data by roomorareaid
                const onetimeKey = OnetimekeyData?.find(otk => otk.roomnoid === lock.roomorareaid);

                if (onetimeKey && onetimeKey.reservationid === dummyId) {
                    // If reservationid is dummyId, only check isavailable
                    return { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' }

                }
            }

            // Original logic for non-onetime keys or when reservationid is not dummyId
            if (!reservation) {
                return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
            }

            const guest = getGuestDetailsFromReservation(reservation, DigitalkeyData?.fullcontact);
            if (!guest) {
                return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
            }

            const currentDateOnly = new Date(new Date(PropertyData?.systemdate).toDateString());
            const checkoutDateOnly = new Date(new Date(guest.checkoutdate || reservation.checkoutdate).toDateString());
            const isExpired = currentDateOnly > checkoutDateOnly;
            const isGuestInactive = guest.isactive === 0;
            const isCheckedOut = reservation.ischeckout === 1;
            const isNotCheckedOut = reservation.ischeckout === 0;
            const isAllInactive = reservation.ischeckin === 0 && reservation.ischeckout === 0 &&
                reservation.iscancel === 0 && reservation.noshow === 0;

            if (lock.isonetimekey) {
                return { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' }
            }

            if (isGuestInactive) {
                return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
            }

            if (isCheckedOut) {
                return { id: 2, subtitle: 'Expired', className: 'unlock-card-expired', textclassName: 'unlock-card-expired-text' };
            }

            if (isExpired) {
                return { id: 2, subtitle: 'Expired', className: 'unlock-card-expired', textclassName: 'unlock-card-expired-text' };
            }

            if (isVisible && isNotCheckedOut) {
                if (isAllInactive && reservation.noshow === 0) {
                    return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
                }
                if (!lock.timings?.length || isWithinTimingRange) {
                    return { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' };
                }
                return { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
            }

            if (isAllInactive && reservation.noshow === 0 && reservation.isopen === 0) {
                return { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
            }

            if (!isWithinTimingRange && isVisible && lock.timings && isNotCheckedOut) {
                return { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
            }

            return { id: 2, subtitle: 'Expired', className: 'unlock-card-expired', textclassName: 'unlock-card-expired-text' };
        };

        // Check if lock is within timing
        const evaluateLock = (lock) => {
            if (!lock.timings?.length) return true;
            for (let i = 0; i < lock.timings.length; i++) {
                const timing = lock.timings[i];
                const fromMinutes = getTimeInMinutes(IISMethods.GetISOtoTZtime(timing.fromtime));
                const toMinutes = getTimeInMinutes(IISMethods.GetISOtoTZtime(timing.totime));
                if (currentMinutes >= fromMinutes && currentMinutes <= toMinutes) return true;
            }
            return false;
        };

        // Transform locks
        const transformedLocks = [];

        for (let i = 0; i < groupData.length; i++) {
            const { groupid, groupname, lockdata = [], isblacklist = 0 } = groupData[i];

            if (groupid === dummyId) {
                for (let j = 0; j < lockdata.length; j++) {
                    const lock = lockdata[j];
                    const isWithin = evaluateLock(lock);
                    let status;
                    let reservationId = null;
                    if (lock.isroomorarea === 1) {
                        const boundReservationIds = [];
                        if (lock.roomnoid && Array.isArray(lock.roomnoid)) {
                            for (const roomId of lock.roomnoid) {
                                const reservation = findReservationByRoomId(roomId);
                                if (reservation) {
                                    boundReservationIds.push(reservation._id);
                                }
                            }
                        }
                        reservationId = boundReservationIds.length > 0 ? boundReservationIds : null;

                        status = getAreaLockStatus(lock, isWithin);
                    } else {
                        const reservation = findReservationByRoomId(lock.roomorareaid);
                        reservationId = reservation?._id || null;
                        status = getRoomLockStatus(lock, isWithin);
                    }

                    transformedLocks.push({
                        ...status,
                        title: lock.lockname?.toString() || '',
                        lockid: [lock.lockid],
                        isroomorarea: lock.isroomorarea,
                        roomorareaid: lock.roomorareaid,
                        isonetimekey: lock.isonetimekey,
                        timings: lock.timings || [],
                        roomnoid: lock.roomnoid || [],
                        reservationId: reservationId,
                        isblacklist: isblacklist,
                        isavailable: lock.isavailable
                    });
                }
            } else if (lockdata.length) {
                const firstLock = lockdata[0];
                let groupStatus;
                let groupReservationIds = null;

                if (firstLock.isroomorarea === 1) {
                    const validAreaLocks = [];
                    const allReservationIds = new Set();

                    for (const lock of lockdata) {
                        const isWithin = evaluateLock(lock);
                        const lockStatus = getAreaLockStatus(lock, isWithin);

                        if (lock.roomnoid && Array.isArray(lock.roomnoid)) {
                            for (const roomId of lock.roomnoid) {
                                const reservation = findReservationByRoomId(roomId);
                                if (reservation) {
                                    allReservationIds.add(reservation._id);
                                }
                            }
                        }

                        if (lockStatus.id === 1 && (!lock.timings?.length || isWithin)) {
                            validAreaLocks.push(lock.lockid);
                        }
                    }

                    groupReservationIds = Array.from(allReservationIds);

                    if (validAreaLocks.length > 0) {
                        groupStatus = { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' };
                    } else {
                        const allStatuses = lockdata?.map(lock => getAreaLockStatus(lock, evaluateLock(lock)));
                        const hasExpired = allStatuses.some(s => s.id === 2);
                        const allUnavailable = allStatuses.every(s => s.id === 3);
                        const hasClosed = allStatuses.some(s => s.id === 4);

                        if (allUnavailable) {
                            groupStatus = { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
                        } else if (hasExpired) {
                            groupStatus = { id: 2, subtitle: 'Expired', className: 'unlock-card-expired', textclassName: 'unlock-card-expired-text' };
                        } else if (hasClosed) {
                            groupStatus = { id: 4, subtitle: 'Closed', className: 'unlock-card-closed', textclassName: 'unlock-card-closed-text' };
                        } else {
                            groupStatus = { id: 3, subtitle: 'Unavailable', className: 'unlock-card-unavailable', textclassName: 'unlock-card-unavailable-text' };
                        }
                    }

                    transformedLocks.push({
                        ...groupStatus,
                        title: groupname || '',
                        lockid: validAreaLocks,
                        isroomorarea: firstLock.isroomorarea,
                        roomorareaid: groupid,
                        timings: firstLock.timings || [],
                        isonetimekey: firstLock.isonetimekey,
                        roomnoid: firstLock.roomnoid || [],
                        reservationId: groupReservationIds,
                        isblacklist: isblacklist,
                        isavailable: firstLock.isavailable
                    });
                } else {
                    const groupReservation = findReservationByRoomId(groupid);
                    groupReservationIds = groupReservation?._id || null;

                    const validRoomLocks = lockdata.filter(lock => {
                        const isWithin = evaluateLock(lock);
                        const status = getRoomLockStatus(lock, isWithin);
                        return status.id === 1;
                    })?.map(l => l.lockid);

                    const status = validRoomLocks.length > 0 ?
                        { id: 1, subtitle: 'Tap to Unlock', className: 'unlock-card-tap', textclassName: 'unlock-card-tap-text' } :
                        getRoomLockStatus(firstLock, evaluateLock(firstLock));

                    transformedLocks.push({
                        ...status,
                        title: groupname || '',
                        lockid: validRoomLocks,
                        isroomorarea: firstLock.isroomorarea,
                        isonetimekey: firstLock.isonetimekey,
                        roomorareaid: groupid,
                        timings: firstLock.timings || [],
                        reservationId: groupReservationIds,
                        isblacklist: isblacklist,
                        isavailable: firstLock.isavailable
                    });
                }
            }
        }

        return transformedLocks;
    };

    const MultipleCardElements = useMemo(() => {
        const currentMinutes = serverTime ? serverTime.getHours() * 60 + serverTime.getMinutes() : 0;
        const order = [1, 4, 3, 2]; // required order
        return MultipletransformLockData({ currentMinutes })
            ?.sort((a, b) => {
                // First, prioritize one-time keys
                if (a.isonetimekey && !b.isonetimekey) return -1;
                if (!a.isonetimekey && b.isonetimekey) return 1;

                // Then apply the original custom sorting by id
                return order.indexOf(a.id) - order.indexOf(b.id);
            })
            .map((card, index) => {

                // Modify subtitle if it's a one-time key
                const subtitle = card.isonetimekey
                    ? `${card.subtitle}`
                    : card.subtitle;

                return (
                    <div
                        key={`${card.lockid || card.id}-${index}`}
                        className={`unlock-card-wrapper ${card.id === 1 ? 'clickable' : 'disabled'}`}
                        onClick={async () => {
                            if (card.id === 1 && !card.isblacklist && card.isavailable) {
                                props.handleCardClick(card, '');
                            }
                        }}
                        style={{ cursor: card.id === 1 ? 'pointer' : 'default' }}
                    >
                        <div className={`unlock-card-top ${card.isblacklist === 1 || !card.isavailable ? 'unlock-card-unavailable' : card.className}`}>
                            <div className="unlock-card-icon-circle">
                                <img src={lock} alt="Lock Icon" />
                            </div>
                        </div>
                        <div className="unlock-card-bottom">
                            <div className="unlock-card-title">{card.title}</div>
                            <div className={`unlock-card-subtitle ${card.isblacklist === 1 || !card.isavailable ? 'unlock-card-unavailable-text' : card.textclassName}`}>
                                {/* {subtitle} */}
                                {
                                    card.isonetimekey ?
                                        <div>
                                            <p className='mb-1'>{card.isblacklist === 1 || !card.isavailable ? 'Unavailable' : subtitle}</p>
                                            <p className='mb-0'>{`(One Time)`}</p>
                                        </div>
                                        :
                                        card.isblacklist === 1 || !card.isavailable ? 'Unavailable' : subtitle
                                }
                            </div>
                        </div>
                    </div>
                );
            });
    }, [serverTime, props.LinkData, props.visible]);


    const statusOrder = ["Departing", "In House", "Arriving", "Checked Out"];
    const sortedReservations = Array.isArray(props.LinkData?.ReservationData) ? props.LinkData.ReservationData?.map(res => ({
        ...res, guestStatus: props.getGuestStatus(res)
    })).sort((a, b) => statusOrder.indexOf(a.guestStatus) - statusOrder.indexOf(b.guestStatus)) : [];

    const handleMultiRoom = (room = {}) => {
        props.setMultiRoom(prev =>
            prev.some(r => r._id === room._id)
                ? prev.filter(r => r._id !== room._id)
                : [...prev, room]
        );
    }

    let isblacklist = props.isblacklistCheck()
    const digitalKey = props.LinkData?.DigitalkeyData;
    const onetimeKey = props.LinkData?.OnetimekeyData;
    const reservationData = props.LinkData?.ReservationData;
    const areaDashboardData = props.LinkData?.AreaDashboardData;
    const propertyData = props.LinkData?.PropertyData;

    const allCheckedOut = reservationData?.length > 0 && reservationData.every(res => res.ischeckout === 1);
    const isOneTimeDigitalKey =
        (digitalKey?.isonetimekey === 1 && digitalKey?.reservationid !== Config.dummyid) ||
        (onetimeKey?.length && (!reservationData?.length || (reservationData?.length && allCheckedOut)));

    const showOneTimeMessage = isOneTimeDigitalKey && !areaDashboardData?.length;

    const showShareButton = !showOneTimeMessage && propertyData?.enablesharekey && !isblacklist && !allCheckedOut;

    return (
        <>
            <div className="digital-key-container">
                <Header title='Digital Key' />
                {props.loadingCardId
                    ?
                    <UnlockingLoader data={props.lockdata} />
                    :
                    <>
                        <div className="unlock-container">
                            <div className={`unlock-title margin-15`}>
                                {showOneTimeMessage
                                    ? 'This is a one-time use digital key.'
                                    : allCheckedOut
                                        ? 'Thank you for your stay!'
                                        : 'Enjoy Your Stay!'}
                            </div>
                            {
                                <div className="multiple-unlock-stay-info-wrapper">
                                    <div className={`multiple-unlock-stay-info ${sortedReservations?.length === 1 ? 'content-center' : ""}`}>
                                        {sortedReservations?.map((res, i) => {
                                            const checkintime = props.getCheckInTime(res.checkindate) //props.LinkData?.PropertyData?.timing?.checkintime;
                                            const checkedouttime = props.LinkData?.PropertyData?.timing?.checkouttime;
                                            const formattedCheckin = IISMethods.formatDateTime(res.checkindate, checkintime);
                                            const formattedCheckout = IISMethods.formatDateTime(res.checkoutdate, res.keyexpiretime ? res.keyexpiretime : checkedouttime);
                                            const GuestClassName = res.guestStatus?.replace(/\s+/g, '').toLowerCase();
                                            return (
                                                <div
                                                    key={i}
                                                    className={`multiple-unlock-stay-card multiple-status-${GuestClassName} `}
                                                >
                                                    <div className="multiple-room-label">Room {res.roomno}</div>

                                                    <p className={`multiple-text-line`}>
                                                        <b>Check-In:</b> <span>{formattedCheckin?.formattedDate}, {formattedCheckin?.formattedTime}</span>
                                                    </p>
                                                    <p className={`multiple-text-line`}>
                                                        <b>Check-Out:</b> <span>{formattedCheckout?.formattedDate}, {formattedCheckout?.formattedTime}</span>
                                                    </p>
                                                    <p className={`multiple-text-line`}>
                                                        <b>{[0, 1].includes(res.noofnight) ? "Night" : "Nights"}:</b> <span>{[0, 1].includes(res.noofnight) ? 1 : res.noofnight}</span>
                                                    </p>

                                                    <p className={`multiple-text-line`}>
                                                        <b>Status:</b>{" "}
                                                        <span className="multiple-status-badge">{res.guestStatus}</span>
                                                    </p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="unlock-card-grid-wrapper">
                            <div className="unlock-card-grid mt-3">
                                {/* Render Card List */}
                                {MultipleCardElements}
                            </div>
                        </div>
                        {/* && guestDetails?.isactive === 1 */}
                        {showShareButton ? (
                            <div className="button-group mt-auto mb-2"
                                onClick={() => props.handleGrid(1, 'modal', 'sharekey', true)}>
                                <button className="share-code-button">
                                    <img src={backarrow} alt="Lock Icon" className="mr-2" />
                                    Share Your Key
                                </button>
                            </div>
                        ) : <></>}
                    </>
                }
            </div>

            <ModalRSuite
                size={'sm'}
                open={getCurrentState().modal?.sharekey}
                className={'share-key-modal'}
                closeButton={true}
                onClose={() => { props.setMultiRoom([]); props.handleGrid(0, 'modal', 'sharekey', false); setPhoneError(false); getCurrentState().formData.phoneno = ''; setProps({ formData: IISMethods.getCopy(getCurrentState().formData) }) }}
                body={
                    <div className='col-12'>
                        <p className='text-18 mb-3 font-weight-600 text-center'>Share Your Key</p>
                        <div className="form-group">
                            <label className="text-14 font-weight-600 text-dark mb-2 mt-1">Mobile Number</label>
                            <TelephoneInput
                                countryCode="US"
                                className={`flag-input country-input ${phoneError ? 'error-border' : ''}`} // 🔥 Add error class
                                placeholder="Enter Mobile Number"
                                inputValue={getCurrentState().formData?.phoneno}
                                onInputChange={handlePhoneInputChange}
                                countryflag={getCurrentState().formData.phonenocountryid ? getCurrentState().formData.phonenocountryid : Config.countryid}
                                onCountryChange={(country) => props.handleFormData('intl-flagchange', 'phoneno', country)}
                            />
                            {phoneError && <div className="error-text">Please enter a valid mobile number</div>}
                        </div>
                        <div className={`${Array.isArray(getCurrentState().linkData?.ReservationData) && getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.length > 1 ? 'right-sidebar-content p-2' : 'd-none'}`} style={{ backgroundColor: '#f5f7f9', borderRadius: '10px' }}>
                            <div className="row">
                                <div className="col-12 ">
                                    <div className={`task-btn-custom-control d-flex justify-content-between`} id={"form-" + 'overridemerge'}>
                                        <p className='text-16 font-weight-500 mb-0'>Room No.</p>
                                        <button className={`send-link-button text-14 px-2 py-1 w-auto  font-weight-500 ${getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.length === props.multiRoom?.length ? 'withAllRoom' : 'withoutAllRoom'}`} id="btnupdate" type="button"
                                            onClick={async () => {
                                                if (props.multiRoom?.length === getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.length) {
                                                    props.setMultiRoom([])
                                                } else {
                                                    Array.isArray(getCurrentState().linkData?.ReservationData) && props.setMultiRoom(getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.map(r => ({ _id: r._id, roomno: r.roomno })))
                                                }
                                            }}>{<Loader size="sm" content={'All'} />}</button>
                                    </div>
                                </div>
                                <div className={`${getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.length ? 'col-12  d-flex  align-items-center justify-content-center mt-2 ' : 'd-none'}`}>
                                    <div className="" style={{ display: 'grid', gridTemplateColumns: 'repeat(4 ,1fr)', maxHeight: "150px", overflow: 'scroll', overflowX: 'hidden' }}>
                                        {
                                            Array.isArray(getCurrentState().linkData?.ReservationData) && getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.length ?
                                                getCurrentState().linkData?.ReservationData?.filter(rd => !rd.iscancel && !rd.ischeckout && !rd.noshow)?.map(({ roomno, _id }, roomdataindex) => {
                                                    let borderColor = props.multiRoom?.length && props.multiRoom.some(rd => rd._id === _id) ? 'green' : 'gray';
                                                    return (
                                                        <div className={`roomblock position-relative`}>
                                                            <div
                                                                className="mx-1 mb-1 mt-2 cursor-pointer"
                                                                style={{
                                                                    minWidth: 65,
                                                                    height: 41,
                                                                    border: `2px solid ${borderColor}`,
                                                                    borderRadius: '8px',
                                                                    transition: 'all 0.2s'
                                                                }}
                                                                key={roomdataindex}
                                                                onClick={() => { handleMultiRoom({ _id, roomno }) }}
                                                            >
                                                                <label className="tree-tag-text content-center position-relative" style={{ height: 37 }}>
                                                                    {roomno}
                                                                </label>
                                                            </div>
                                                            <div className={`${props.multiRoom.some(rd => rd._id === _id) ? 'svg-position' : 'd-none'}`}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 164 164" fill="none">
                                                                    <g clip-path="url(#clip0_63_42)">
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M71.0242 152.944C31.8473 152.944 0 121.096 0 81.9193C0 42.7424 31.8473 10.8948 71.0242 10.8948C88.9893 10.8948 105.848 17.4197 118.982 29.4597C114.614 32.043 110.398 34.9045 106.343 38.0018C96.3904 29.973 84.0159 25.5525 71.0242 25.5525C39.9759 25.5525 14.6577 50.871 14.6577 81.9193C14.6577 112.968 39.9759 138.286 71.0242 138.286C114.225 138.286 139.874 92.1078 121.292 56.2035C124.109 53.5847 127.007 51.0464 129.982 48.5927C130.861 47.8682 131.747 47.1505 132.639 46.4399C138.855 57.1756 142.05 69.3479 142.05 81.9189C142.049 121.096 110.201 152.944 71.0242 152.944Z" fill="black" />
                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M72.89 118.431C72.0906 118.431 71.4243 117.898 71.1578 117.232C71.0248 116.965 59.5646 87.3826 41.8417 76.1892C38.377 74.0571 35.7125 71.7917 36.7783 66.7279C37.8441 61.7975 41.1757 58.9992 47.1719 57.6665C57.832 55.4011 69.2919 71.9247 73.5563 78.7211C88.4805 57.0006 118.33 22.8871 161.77 18.8895C163.866 18.6439 164.641 21.7502 162.703 22.6207C162.037 22.8871 99.9399 51.2709 74.7552 117.365C74.3557 118.031 73.6893 118.431 72.89 118.431Z" fill="#34C759" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_63_42">
                                                                            <rect width="163.839" height="163.839" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    );
                                                }) : <></>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div >
                        <div className="button-group mt-3" onClick={handleSendClick}>
                            <button className={`send-link-button ${props.loader ? 'disable-button' : ''}`} disabled={props.loader}> <Loader size="sm" loading={props.loader} content={"Send Link"} /></button>
                        </div>
                    </div>
                }
            />
        </>
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    setProps: (payload) => dispatch(setProps(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(UnlockDoorView)

